import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function Cube({ className }) {
    return (_jsx("div", { className: `deallock-loading-cube relative float-left h-1/2 w-1/2 scale-110 ${className}`, children: _jsx("span", { className: "deallock-loading-cube-face" }) }));
}
/**
 * Just the 4-cube folding animation + its styles, with no positioning of its own.
 * Use directly when you want to scope the loading indicator to a section
 * (wrap it in your own positioned container). Use `Loading` for the full-screen overlay.
 */
export function LoadingCubes() {
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
        @keyframes deallock-fold-cube-angle {
          0%, 10% {
            transform: perspective(140px) rotateX(-180deg);
            opacity: 0;
          }
          25%, 75% {
            transform: perspective(140px) rotateX(0deg);
            opacity: 1;
          }
          90%, 100% {
            transform: perspective(140px) rotateY(180deg);
            opacity: 0;
          }
        }
        .deallock-loading-cube-face {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #333;
          animation: deallock-fold-cube-angle 2.4s infinite linear both;
          transform-origin: 100% 100%;
          display: block;
        }
        .deallock-loading-cube.cube2 {
          transform: scale(1.1) rotateZ(90deg);
        }
        .deallock-loading-cube.cube2 .deallock-loading-cube-face {
          animation-delay: 0.3s;
        }
        .deallock-loading-cube.cube3 {
          transform: scale(1.1) rotateZ(180deg);
        }
        .deallock-loading-cube.cube3 .deallock-loading-cube-face {
          animation-delay: 0.6s;
        }
        .deallock-loading-cube.cube4 {
          transform: scale(1.1) rotateZ(270deg);
        }
        .deallock-loading-cube.cube4 .deallock-loading-cube-face {
          animation-delay: 0.9s;
        }
      ` }), _jsx("div", { className: "relative size-[60px] flex-none", children: _jsxs("div", { className: "absolute left-1/2 z-[2] mt-6 h-10 w-10 -translate-x-1/2 rotate-45", children: [_jsx(Cube, { className: "cube1" }), _jsx(Cube, { className: "cube2" }), _jsx(Cube, { className: "cube3" }), _jsx(Cube, { className: "cube4" })] }) })] }));
}
export default function Loading({ isVisible, title }) {
    return (_jsxs("div", { className: `fixed inset-0 z-30 flex flex-col items-center justify-center bg-white transition-[opacity,visibility] duration-300 ${isVisible ? 'visible opacity-100' : 'invisible opacity-0'}`, children: [_jsx("div", { className: "mb-[15px]", children: _jsx(LoadingCubes, {}) }), title && (_jsxs("div", { className: "font-bold text-[#10220f]", children: [title, _jsx("span", { className: "absolute", children: "..." })] }))] }));
}
